export default __webpack_public_path__ + "static/media/pg.bbb676aa.png";